<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import {required} from "vuelidate/lib/validators";
import appConfig from "@/app.config.json";
import {notifyModel} from "@/models/notifyModel";
import {pagingModel} from "@/models/pagingModel";
import {fileModel} from "@/models/fileModel";
import vue2Dropzone from "vue2-dropzone";
export default {
  page: {
    title: "Quản lý file",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {Layout, PageHeader,vueDropzone: vue2Dropzone,  },
  data() {
    return {
      title: "Quản lý file",
      items: [
        {
          text: "Quản lý file",
          href: "/quan-ly-file",
        },
        {
          text: "Danh sách",
          active: true,
        }
      ],
      data: [],
      showModal: false,
      showDetail: false,
      showDeleteModal: false,
      submitted: false,
      model: fileModel.baseJson(),
      listRole: [],
      pagination: pagingModel.baseJson(),
      totalRows: 1,
      todoTotalRows: 1,
      currentPage: 1,
      numberOfElement: 1,
      perPage: 10,
      pageOptions: [5, 10, 25, 50, 100],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: 'STT', label: 'STT',
          class: "text-center td-sttt",
          tdClass: 'align-middle',
          thClass: 'hidden-sortable'
        },
        {
          key: "file",
          label: "Tên file",
          class: "td-mthutuc",
          thStyle: "text-align:center",
          thClass: 'hidden-sortable'
        },
        {
          key: 'process',
          label: 'Xử lý',
          class: "text-center td-xl",
          thClass: 'hidden-sortable'
        }
      ],
      listLinhVuc : [],
      listDonVi : [],
      listMucDo: [],
      listFile : [],
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}files/upload`,
        thumbnailWidth: 300,
        thumbnailHeight: 160,
        maxFiles: 4,
        maxFilesize: 30,
        headers: {"My-Awesome-Header": "header value"},
        addRemoveLinks: true,
        acceptedFiles: ".jpeg,.jpg,.png,.gif,.doc,.docx,.xlsx,.pptx,.pdf",
      },
      urlFile:`${process.env.VUE_APP_API_URL}files/view`,
      apiView: `${process.env.VUE_APP_API_URL}files/dowload`,
    };
  },
  validations: {
    model: {
      name:{required},
    },
  },
  created() {
  },
  watch: {
    model: {
      deep: true,
      handler(val) {
      }
    },
    showModal(status) {
      if (status == false) this.model = fileModel.baseJson();
    },
    showDeleteModal(val) {
      if (val == false) {
        this.model.id = null;
      }
    },
  },
  methods: {

    uploadFile(files,response) {
      let fileSuccess = response.data;
      console.log('log suscess', response.data)
      if (response.code == 0){
        this.model.files.push({
          fileId: fileSuccess.id,
          fileName: fileSuccess.fileName,
          ext: fileSuccess.ext,
          path: fileSuccess.path
        });
      }
      console.log('log model file', this.model.files)

    },
    removeThisFile(files, error, xhr) {
      let fileCongViec = JSON.parse(files.xhr.response);
      if (fileCongViec.data && fileCongViec.data.fileId) {
        let idFile = fileCongViec.data.fileId;
        let resultData = this.model.files.filter(x => {
          return x.fileId != idFile;
        })
        this.model.file = resultData;
        //  console.log('log model file remove', this.modelContent.files)
      }
    },

    sendingEvent(file, xhr, formData) {
      formData.append("files", file);
    },
    async handleDetail(id) {
      await this.$store.dispatch("fileStore/getById", {id : id}).then((res) => {
        if (res.code === 0) {
          this.model = fileModel.fromJson(res.data);
         // console.log("LOG MODEL DETAIL ", this.model)
          this.showDetail = true;
        } else {
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
        }
      });
    },
    async handleDelete() {
      if (this.model.id != 0 && this.model.id != null && this.model.id) {
        await this.$store.dispatch("fileStore/delete", {id : this.model.id}).then((res) => {
          if (res.code === 0) {
            this.showDeleteModal = false;
            this.$refs.tblList.refresh()
          }
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
          // });
        });
      }
    },
    handleShowDeleteModal(id) {
      this.model.id = id;
      this.showDeleteModal = true;
    },

    async handleSubmit(e) {
      e.preventDefault();
      this.submitted = true;
      if (this.model == null || (this.model != null && (this.model.files == null ||  this.model.files.length == 0))) {
        this.$store.dispatch("snackBarStore/addNotify", {
          message: "Vui lòng chọn hình ảnh trước khi lưu ",
          code: 20,
        });
        return;
      } else {
        let loader = this.$loading.show({
          container: this.$refs.formContainer,
        });
        await this.$store.dispatch("fileStore/create", this.model).then((res) => {
          if (res.code === 0) {
            this.model = null;
            this.showModal = false;
            this.$refs.tblList.refresh();
          }
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res))
        });
        loader.hide();
        this.submitted = false;
      }
      this.submitted = false;
    },
    myProvider(ctx) {
      const params = {
        start: ctx.currentPage,
        limit: ctx.perPage,
        sortBy: ctx.sortBy,
        sortDesc: ctx.sortDesc,
      }
      this.loading = true
      try {
        let promise = this.$store.dispatch("fileStore/getPagingParams", params)
        return promise.then(resp => {
          let items = resp.data.data
          this.totalRows = resp.data.totalRows
          this.numberOfElement = resp.data.data.length
          this.loading = false
          return items || []
        })
      } finally {
        this.loading = false
      }
    },
  }
}
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-12">
                <div class="text-sm-end">
                  <b-button type="button" class="btn-label bg-color mb-2 me-2" @click="showModal = true" size="sm"
                  >
                    <i class="mdi mdi-plus me-1 label-icon"></i> Thêm
                  </b-button>
                  <b-modal
                      v-model="showModal"
                      title="Thông tin ngữ cảnh"
                      title-class="text-black font-18"
                      body-class="p-3"
                      hide-footer
                      centered
                      no-close-on-backdrop
                      size="lg"
                  >
                  <form @submit.prevent="handleSubmit"
                          ref="formContainer"
                    >
                      <div class="row">
                        <div class="col-12" >
                          <label class="text-left">Chọn file</label>
                          <template  v-if="model.file" >
                            <a
                                class="ml-25"
                                :href="`${urlFile}/${model.file}`"
                            >
                            {{model.fileName }}</a>
                              <b-button
                                  variant="flat-danger"
                                  class="btn-icon"
                                  @click="deleteFile()"
                              >
                                <i class="mdi mdi-trash-can-outline"></i>
                              </b-button>

                          </template>

                          <vue-dropzone
                              id="dropzone"
                              ref="myVueDropzone"
                              :use-custom-slot="true"
                              :options="dropzoneOptions"
                              v-on:vdropzone-sending="sendingEvent"
                              v-on:vdropzone-removed-file="removeThisFile"
                              v-on:vdropzone-success="uploadFile"
                          >
                            <div class="dropzone-custom-content">
                              <div class="mb-1">
                                <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                              </div>
                              <h4>Kéo thả tệp hoặc click vào đây để tải tệp tin.</h4>
                            </div>
                          </vue-dropzone>
                        </div>

                      </div>
                      <div class="text-end pt-2 mt-3">
                        <b-button variant="light" @click="showModal = false" class="border-0">
                          Đóng
                        </b-button>
                        <b-button  type="submit" variant="success" class="ms-1 cs-btn-primary">Lưu
                        </b-button>
                      </div>
                    </form>
                  </b-modal>
                </div>
              </div>
            </div>
            <div class="row" style="margin-top: -20px">
              <div class="col-12">
                <div class="row mt-4">
                  <div class="col-sm-12 col-md-6">
                    <div
                        class="col-sm-12 d-flex justify-content-left align-items-center"
                    >
                      <div
                          id="tickets-table_length"
                          class="dataTables_length m-1"
                          style="
                        display: flex;
                        justify-content: left;
                        align-items: center;
                      "
                      >
                        <div class="me-1" >Hiển thị </div>
                        <b-form-select
                            class="form-select form-select-sm"
                            v-model="perPage"
                            size="sm"
                            :options="pageOptions"
                            style="width: 70px"
                        ></b-form-select
                        >&nbsp;
                        <div style="width: 100px"> dòng</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="table-responsive-sm">
                  <b-table
                      class="datatables table-size"
                      :items="myProvider"
                      :fields="fields"
                      striped
                      bordered
                      responsive="sm"
                      :per-page="perPage"
                      :current-page="currentPage"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :filter="filter"
                      :filter-included-fields="filterOn"
                      ref="tblList"
                      primary-key="id"
                  >
                    <template v-slot:cell(STT)="data">
                      {{ data.index + ((currentPage - 1) * perPage) + 1 }}
                    </template>
                    <template v-slot:cell(file)="data">
                      <div v-if="data.item != null && data.item.file">
                        {{data.item.file.fileName}}
                      </div>

                    </template>
                    <template v-slot:cell(process)="data">
                      <button
                          type="button"
                          size="sm"
                          class="btn btn-outline btn-sm btn-xl">
                          <div v-if="data.item != null && data.item.file">
                            <a
                                :href="`${urlFile}/${data.item.file.fileId}`"
                                class="text-dark fw-medium d-flex justify-content-center align-items-center">
                              <div class="">
                                <!-- <i
                                    :class="`${getColorWithExtFile(item.ext)} me-2 ${getIconWithExtFile(item.ext)}`"
                                ></i>
                                <span style="font-weight: bold">{{ item.fileName }}</span> -->
                                <i class="mdi mdi-cloud-download" style="font-size: 24px; color: #B50027;"></i>
                              </div>
                            </a>
                          </div>
                      </button>
                      <button
                          type="button"
                          size="sm"
                          class="btn btn-outline btn-sm btn-xl"
                          data-toggle="tooltip" data-placement="bottom" title="Xóa"
                          v-on:click="handleShowDeleteModal(data.item.id)">
                        <i class="mdi mdi-delete text-danger me-1 fs-15"></i>
                      </button>
                    </template>
                    <template v-slot:cell(ten)="data">&nbsp;&nbsp;
                      {{ data.item.ten }}
                    </template>
                  </b-table>
                </div>
                <div class="row">
                  <b-col>
                    <div>Hiển thị {{ numberOfElement }} trên tổng số {{ totalRows }} dòng</div>
                  </b-col>
                  <div class="col">
                    <div
                        class="dataTables_paginate paging_simple_numbers float-end">
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <b-modal
            v-model="showDeleteModal"
            centered
            title="Xóa dữ liệu"
            title-class="font-18"
            no-close-on-backdrop
        >
          <p>
            Dữ liệu xóa sẽ không được phục hồi!
          </p>
          <template #modal-footer>
            <button v-b-modal.modal-close_visit
                    class="btn btn-outline-info m-1"
                    v-on:click="showDeleteModal = false">
              Đóng
            </button>
            <button v-b-modal.modal-close_visit
                    class="btn btn-danger btn m-1"
                    v-on:click="handleDelete">
              Xóa
            </button>
          </template>
        </b-modal>
      </div>
    </div>
  </Layout>
</template>

<style>
.fs-10{
  font-size: 10px;
}

.td-sttt{
  width: 4%;
}
.td-mthutuc{
  width: 35%;
}
.td-thutuc{
  width: 30%;
}

.td-sl{
  width: 8%;
}
.td-xl{
  width: 8%;
}

.badge-linhvuc{
  color: #204b03;
  border-radius: 5px;
  background-color: #204b0347;
  padding: 5px;
}

.badge-soft-primary{
  padding: 5px;
}
.badge-danger{
  color: #f44336;
  border-radius: 5px;
  background-color: #f4433644;
}
.btn-xl{
  padding: 0px;
}
.multiselect__option--highlight, .multiselect__option--highlight:after{
  background-color: #204b03 !important;
}
</style>
